// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1__bc8eded01d33a7b3d014","cls2":"QuestionStyles-cls2__ec08a0aa32248b9311dd QuestionStyles-cls1__bc8eded01d33a7b3d014"};